var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layout-Android",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12.3-Processando",
    transform: "translate(-145.000000, -185.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(87.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel-(1)",
    transform: "translate(58.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8644668,39.9331992 C79.8644668,17.877505 61.985996,0.000482897384 39.9327163,0.000482897384 C17.8784708,0.000482897384 0,17.8773441 0,39.9331992 C0,61.985835 17.8784708,79.8639839 39.9327163,79.8639839 C61.985996,79.8639839 79.8644668,61.985835 79.8644668,39.9331992 Z",
    id: "Path",
    fill: "#F14747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5942857,39.9327163 L56.2688129,26.3800402 C57.5420523,24.9020523 57.3756137,22.6712274 55.8969819,21.3979879 C54.4206036,20.1257143 52.1896177,20.2911871 50.9155734,21.7691751 L39.9319115,34.5195976 L28.9493763,21.7691751 C27.6761368,20.2902213 25.4449899,20.1247485 23.966841,21.3979879 C22.4882093,22.6712274 22.3227364,24.9022133 23.5959759,26.3800402 L35.2695372,39.9327163 L23.5959759,53.4847485 C22.3227364,54.9627364 22.4882093,57.1935614 23.966841,58.4668008 C24.6337223,59.0412877 25.454326,59.3228169 26.2712274,59.3228169 C27.2629376,59.3228169 28.2501408,58.9065594 28.9493763,58.0956137 L39.9319115,45.3451911 L50.9155734,58.0956137 C51.6138431,58.9070423 52.6008853,59.3228169 53.5935614,59.3228169 C54.409497,59.3228169 55.2302616,59.0412877 55.8971429,58.4668008 C57.3757746,57.1935614 57.5422133,54.9625755 56.2689738,53.4847485 L44.5942857,39.9327163 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f6271c1ca0d055aa3f63621de01edbe3.svg";
export { ForwardRef as ReactComponent };